module.exports = __webpack_public_path__ + "img/es-ib.f1382a29.svg";